import { fetch } from '@/service/fetch/index'

/**
 * @param {财务对账} opt
 */
// 对账
export function checkAccount (option) {
  return fetch('/aomi-transport/tsacCustomer/checkAccount', option)
}

// 获取供应商分润数据
export function getData (option) {
  return fetch('/aomi-transport/tsacCustomer/getData', option)
}

// 供应商每月对账状态
export function getCustAcState (option) {
  return fetch('/aomi-transport/tsacCustomer/getCustAcState', option)
}

// 对账汇总数据
export function getStatistic (option) {
  return fetch('/aomi-transport/tsacCustomer/getStatistic', option)
}

// 申訴
export function updateAppealState (option) {
  return fetch('/aomi-transport/tsacCustomer/updateAppealState', option)
}
